export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapTunnels';
export const ENTITY_EDIT_ROUTE = 'tunnels/view';
